import { SaveDeliveryPointPayload } from "./delivery-point.model";
import { OrederRemarks } from "./order-remarks.model";

export class SalesOrder {
    orderRemarks: OrederRemarks[];
    orderType: string;
    deliveryPointId: any;
    newDeliveryPoint: SaveDeliveryPointPayload;
    orderStatus: string;
    orderField1: string;
    orderField2: string;
    orderField3: string;
    mode: string;
    signatureImage: string;
    documentNumber: string;
    constructor() {
        this.orderStatus = '';
        this.orderRemarks = [];
        this.mode = 'order';
        this.signatureImage = '';
        this.deliveryPointId = '';
        this.newDeliveryPoint = new SaveDeliveryPointPayload();
        this.documentNumber = '';
    }

}
